import ClauseLibraryTable from './Table';
export default ClauseLibraryTable;
